import { Text } from "../text";

import type { HeadingProps, HeadingTags } from "./heading.types";

const defaultHeadingLevel = 4;

export function Heading({
  children,
  className = "",
  color,
  ellipsis = false,
  headingLevel = defaultHeadingLevel,
  variant = "web-title-xlarge",
  ...props
}: HeadingProps) {
  const level = Number.isInteger(headingLevel)
    ? Math.max(1, Math.min(headingLevel, 6))
    : defaultHeadingLevel;
  const as = `h${level}` as HeadingTags;

  return (
    <Text
      as={as}
      className={className}
      color={color}
      ellipsis={ellipsis}
      variant={variant}
      {...props}
    >
      {children}
    </Text>
  );
}
